module.exports = __webpack_public_path__ + "static/media/Other languages.3e3b3354.svg";